import { Image } from 'antd';
import ph from './photo.svg';

const KoImage = (props) => {
  return (
    <Image preview={false} {...props} fallback={props.fallback ? props.fallback : ph}/>
  );
};
  
export default KoImage;